import { Module } from 'vuex'
import { ElDialog } from '../../../../types/el-dialog'

export interface RootState {
  version?: string;
}

export type LoginType = 'pt' | 'ss'
export interface PrivacyState {
  dialog: ElDialog;
  loading: boolean;
  loginType: LoginType;
}

const namespaced = true
const state: PrivacyState = {
  dialog: {
    visible: false,
    showClose: true
  },

  loading: false,
  loginType: 'pt'
}
const advertiser: Module<PrivacyState, RootState> = {
  namespaced,
  state,

  mutations: {
    updateLoading(state, value: boolean) {
      state.loading = value
    }
  },

  actions: {
    openDialog({ state, dispatch }, { loginType = 'pt' } = {}) {
      state.dialog.visible = true
      state.loginType = loginType
    },

    closeDialog({ state }) {
      state.dialog.visible = false
    }
  }
}

export default advertiser
